import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ServiceImg from "../../assets/website/images/Service-1.webp";
import "../../assets/website/css/testimonialSlide.css";
import { useTranslation } from "react-i18next";

const testimonials = [
  {
    id: 1,
    name: "James R.",
    role: " A Game-Changer for Car Maintenance!",
    feedback: "I used to struggle to find a reliable garage for my car servicing, but Autowiz changed everything! I can compare prices, book appointments easily, and even chat with mechanics before taking my car in. Highly recommend!",
    image: ServiceImg, 
    author : "— James R., Montreal, QC"
  },
  {
    id: 2,
    name: "Linda M.",
    role: "Hassle-Free Car Repairs!",
    feedback: "Finding a trustworthy mechanic has always been a challenge, but Autowiz made it so simple! I got multiple quotes, scheduled a service, and my car was fixed on time. No hidden charges, no stress!",
    image: ServiceImg,
    author: "— Linda M., Markham, ON"
  },
  {
    id: 3,
    name: "Mark T.",
    role: "Great for Busy People!",
    feedback: "As someone with a packed schedule, I love how I can book a service through Autowiz without wasting time calling different garages. The real-time updates and easy payment options are a huge plus!",
    image: ServiceImg,
    author: "— Mark T., Tampa, FL"
  },
  {
    id: 4,
    name: "Sophia K.",
    role: "Transparent Pricing & Honest Reviews",
    feedback: "I was tired of overpaying for car repairs, but Autowiz helped me find a garage with fair pricing and great reviews. Now, I always know what to expect before I book!",
    image: ServiceImg,
    author:"— Sophia K., Ottawa, ON"
  },
  {
    id: 5,
    name: "David P.",
    role: "Perfect for Emergency Repairs!",
    feedback: "My car broke down unexpectedly, and I had no idea where to go. Within minutes, I found a nearby garage on Autowiz, checked reviews, and got my car towed and repaired quickly. Lifesaver!",
    image: ServiceImg,
    author:"— David P., Miami, FL"
  }
];

const testimonialsES = [
  {
    id: 1,
    name: "James R.",
    role: "¡Un cambio radical para el mantenimiento del coche!",
    feedback: "Antes me costaba encontrar un taller confiable para el mantenimiento de mi coche, ¡pero Autowiz cambió todo! Puedo comparar precios, reservar citas fácilmente e incluso chatear con los mecánicos antes de llevar el coche. ¡Muy recomendable!",
    image: ServiceImg,
    author: "— James R., Montreal, QC"
  },
  {
    id: 2,
    name: "Linda M.",
    role: "¡Reparaciones sin complicaciones!",
    feedback: "Siempre ha sido difícil encontrar un mecánico de confianza, ¡pero Autowiz lo hizo muy sencillo! Recibí varios presupuestos, agendé el servicio y mi coche estuvo listo a tiempo. Sin cargos ocultos, sin estrés.",
    image: ServiceImg,
    author: "— Linda M., Markham, ON"
  },
  {
    id: 3,
    name: "Mark T.",
    role: "¡Ideal para personas ocupadas!",
    feedback: "Con una agenda apretada, me encanta poder reservar un servicio en Autowiz sin perder tiempo llamando a diferentes talleres. Las actualizaciones en tiempo real y las opciones de pago fáciles son un gran plus.",
    image: ServiceImg,
    author: "— Mark T., Tampa, FL"
  },
  {
    id: 4,
    name: "Sophia K.",
    role: "Precios transparentes y reseñas honestas",
    feedback: "Estaba cansada de pagar de más por reparaciones, pero Autowiz me ayudó a encontrar un taller con precios justos y buenas reseñas. ¡Ahora siempre sé qué esperar antes de reservar!",
    image: ServiceImg,
    author: "— Sophia K., Ottawa, ON"
  },
  {
    id: 5,
    name: "David P.",
    role: "¡Perfecto para reparaciones de emergencia!",
    feedback: "Mi coche se averió de repente y no sabía a dónde acudir. En minutos, encontré un taller cercano en Autowiz, revisé reseñas y repararon mi coche rápidamente. ¡Una salvación!",
    image: ServiceImg,
    author: "— David P., Miami, FL"
  }
];
const testimonialsFR = [
  {
    id: 1,
    name: "James R.",
    role: "Une révolution pour l’entretien automobile !",
    feedback: "Je peinais à trouver un garage fiable pour l'entretien de ma voiture, mais Autowiz a tout changé ! Je peux comparer les prix, prendre rendez-vous facilement et même discuter avec les mécaniciens avant de m’y rendre. Je recommande vivement !",
    image: ServiceImg,
    author: "— James R., Montreal, QC"
  },
  {
    id: 2,
    name: "Linda M.",
    role: "Des réparations sans tracas !",
    feedback: "Trouver un mécanicien de confiance a toujours été difficile, mais Autowiz a rendu cela si simple ! J'ai obtenu plusieurs devis, pris rendez-vous et ma voiture a été réparée à temps. Pas de frais cachés, aucun stress !",
    image: ServiceImg,
    author: "— Linda M., Markham, ON"
  },
  {
    id: 3,
    name: "Mark T.",
    role: "Parfait pour les personnes occupées !",
    feedback: "Avec mon emploi du temps chargé, j'adore pouvoir réserver un service via Autowiz sans perdre de temps à appeler différents garages. Les mises à jour en temps réel et les options de paiement faciles sont un gros avantage !",
    image: ServiceImg,
    author: "— Mark T., Tampa, FL"
  },
  {
    id: 4,
    name: "Sophia K.",
    role: "Tarification transparente et avis honnêtes",
    feedback: "J'en avais assez de payer trop cher pour les réparations, mais Autowiz m’a aidée à trouver un garage avec des prix équitables et de bons avis. Maintenant, je sais toujours à quoi m'attendre avant de réserver !",
    image: ServiceImg,
    author: "— Sophia K., Ottawa, ON"
  },
  {
    id: 5,
    name: "David P.",
    role: "Parfait pour les réparations d’urgence !",
    feedback: "Ma voiture est tombée en panne soudainement, et je ne savais pas où aller. En quelques minutes, j’ai trouvé un garage proche sur Autowiz, consulté les avis, et ma voiture a été remorquée et réparée rapidement. Sauvé !",
    image: ServiceImg,
    author: "— David P., Miami, FL"
  }
];

const TestimonialSlider = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const testimonialsToUse = currentLanguage === "es" ? testimonialsES : currentLanguage === "fr" ? testimonialsFR : testimonials;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonial-section">
      <h2>{t("website.home.WhatOurClientsSayTestimonials")}</h2>
      <p>
        {t("website.home.Dontjusttakeourwordforit")}
      </p>
      <div className="slider-container">

      <Slider {...settings} key={currentLanguage}>
        {testimonialsToUse.map((testimonial) => (
          <div key={testimonial.id}>
            <div className="testimonial-card">
              {/* <img
                src={testimonial.image}
                alt={testimonial.name}
                className="testimonial-image"
                /> */}
              <h3>{testimonial.name}</h3>
              <h4>{testimonial.role}</h4>
              <p>"{testimonial.feedback}"</p>
              <p> {testimonial.author} </p>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
  );
};

export default TestimonialSlider;
